// extracted by mini-css-extract-plugin
export default {"indicator":"Tabs_indicator__7954H"};